import { useId } from 'react';
import SActionButton, { SActionItem } from './SActionButton';

export function SActionList(props: SActionListProps): React.JSX.Element {
    const _componentId = useId();

    return (
        <s-stack
            id={`s-action-list-${_componentId}`}
            direction="block"
            gap="small-300"
            alignItems="start"
            justifyContent="start"
        >
            {props.actions?.filter(Boolean)?.map((action, index) => (
                <SActionButton key={action.id ?? `s-action-list-${_componentId}-action-${index}`} {...action} />
            ))}
        </s-stack>
    );
}

export interface SActionListProps {
    actions: SActionItem[];
}
